module.exports = __webpack_public_path__ + "img/empty-before-after.ae8eaebb.png";